import {
  ChakraProvider,
} from '@chakra-ui/react'
import { useEffect, useMemo, useState } from 'react';
import {
  defaultConfig,
  type UserThemeConfig,
} from '@/theme'
import { useSystemColorMode } from './useSystemColorMode';
import { normalizeConfig } from './normalizeConfig';
import React from 'react';
import { ThemeContext } from './context'


interface ThemeProviderProps {
  config?: UserThemeConfig,
  children?: React.ReactNode
}

const ThemeProvider = (props: ThemeProviderProps) => {
  const {
    config,
    children
  } = props

  const userConfig = {
    ...defaultConfig,
    ...config,
  }

  const systemColorMode = useSystemColorMode()

  const { initColorMode } = userConfig
  const [resolveColorMode, setResolveColorMode] = useState(initColorMode === 'system' ? systemColorMode : initColorMode)

  useEffect(() => {
    const cm = initColorMode === 'system' ? systemColorMode : initColorMode
    setResolveColorMode(cm)
  }, [systemColorMode])


  const colorModeConfig = useMemo(() => {
    const {
      light,
      dark,
    } = normalizeConfig(defaultConfig, userConfig)

    return {
      light,
      dark,
    }
  }, [userConfig.dark, userConfig.light, resolveColorMode]);

  const context = useMemo(() => {
    const toggleColorMode = () => {
      const cm = resolveColorMode === 'dark' ? 'light' : 'dark'
      setResolveColorMode(cm) 
    }

    return {
      ...colorModeConfig,
      colorMode: resolveColorMode,
      setColorMode: setResolveColorMode,
      toggleColorMode,
    }
  }, [colorModeConfig.dark, colorModeConfig.light, resolveColorMode])


  const userTheme = useMemo(() => {
    const theme = context[resolveColorMode]
    return theme
  }, [colorModeConfig.dark, colorModeConfig.light, resolveColorMode])

  return (
    <ThemeContext.Provider value={context as any}>
      <ChakraProvider theme={userTheme}>
        {children}
      </ChakraProvider>
    </ThemeContext.Provider>
  )
}


export {
  ThemeProvider,
  type ThemeProviderProps,
  type UserThemeConfig,
}